import React from 'react'
import PropTypes from 'prop-types'
import Slider from 'rc-slider'

const InputRangePicker = ({ onChange, value, ...rest }) => (
    <Slider
        value={value}
        className={value === 1 ? 'on' : ''} // Slider component expects string so cannot resolve to false if using &&
        onChange={v => onChange(parseInt(v, 10))}
        {...rest}
    />
)

InputRangePicker.propTypes = {
    max: PropTypes.number.isRequired,
    min: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.number.isRequired,
}

export default InputRangePicker



// WEBPACK FOOTER //
// ./src/ui/InputRangePicker.js